export default () => {
  const preloader = document.querySelector(".preloader");
  const logo = document.querySelector(".preloader__logo-wrapper");

  if (!preloader) {
    return;
  }

  if (logo) {
    logo.classList.add('preloader__logo-wrapper--open');
  }
  setTimeout(() => {
    preloader.classList.remove('preloader--open');

    setTimeout(() => {
      preloader.style.display = "none"
    }, 1600)
    
  }, 2600)
}